module.exports = __webpack_public_path__ + "static/ourSeal-95ae029fcf761e974c3f4e4cedf61c81.jpg";